<template>
  <div id="open-platform-detail">
    <common-header></common-header>
    <!--  对接模式  -->
    <open-platform-detail-mode :id="id"></open-platform-detail-mode>
    <!--  技术能力  -->
    <open-platform-detail-capacity v-if="id == 0"></open-platform-detail-capacity>
    <!--  产品能力  -->
    <open-platform-detail-product v-if="id == 0"></open-platform-detail-product>
    <!--  开放平台文档  -->
    <open-platform-detail-doc v-if="id == 1"></open-platform-detail-doc>
    <!--  解决方案  -->
    <open-platform-detail-solution v-if="id == 2"></open-platform-detail-solution>
    <!--  接入流程  -->
    <open-platform-detail-flow :id="id"></open-platform-detail-flow>
    <!--  关于我们 -->
    <open-platform-detail-contact-us></open-platform-detail-contact-us>
  </div>
</template>

<script>
import OpenPlatformDetailMode from "@/components/openPlatform/detailMode";
import OpenPlatformDetailFlow from "@/components/openPlatform/detailFlow";
import OpenPlatformDetailCapacity from "@/components/openPlatform/detailCapacity";
import OpenPlatformDetailProduct from "@/components/openPlatform/detailProduct";
import OpenPlatformDetailDoc from "@/components/openPlatform/detailDoc";
import OpenPlatformDetailSolution from "@/components/openPlatform/detailSolution";
import OpenPlatformDetailContactUs from "@/components/openPlatform/detailContactUs";

export default {
  name: "detail",
  components: {
    OpenPlatformDetailContactUs,
    OpenPlatformDetailSolution,
    OpenPlatformDetailDoc,
    OpenPlatformDetailProduct,
    OpenPlatformDetailCapacity,
    OpenPlatformDetailFlow,
    OpenPlatformDetailMode,
  },
  data() {
    return {
      id: 0,
    }
  },
  created() {
    this.id = this.$queryUrlParams().id;
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
}
</script>

<style scoped lang="scss">

.content-width {
  width: 1200px;
  margin: 0 auto;
}

#open-platform-detail {
  iframe {
    width: 100%;
    min-height: 500px;
  }
}

.open-platform-header {
  text-align: center;
  padding-top: 40px;

  h1 {
    color: #000000;
    font-size: 26px;
  }

  .open-platform-header-line {
    background: #0176D9;
    width: 40px;
    height: 2px;;
    margin: 20px auto;
  }
}
</style>